import { Component, Input } from '@angular/core';

import { Icons } from '@material/icons/icons.config';

// TODO: this is not a container move to components and rename to
// AssignButtonComponent
@Component({
  selector: 'mojo-assign-container',
  templateUrl: './assign-container.component.html',
  styleUrls: ['./assign-container.component.scss'],
})
export class AssignContainerComponent {
  readonly icon = Icons.shortlistCandidate;
  @Input() tooltipText;
  @Input() active = true;
}
